import { merge } from '..';
export function mergeAll(mapping, a, b) {
    mapping.properties.forEach(function (property) { return merge(property, a, b); });
}
//# sourceMappingURL=merge-all.js.map